import React, { useEffect, useState } from 'react';
import {
  RELATIVE_LINKS_PROD,
  RELATIVE_PAGE_PATHS,
  USER_DATA_IN_LOCAL_STORAGE,
} from '../../utils/constants';
import AdSlot from './AdSlot';
import { useLocation } from 'react-router-dom';
import { getAxiosWithToken } from '../../utils/webApi';
import { useSelector } from 'react-redux';

type IAdSlotSpecificPage = {};

const AdSlotSpecificPage: React.FC<IAdSlotSpecificPage> = ({}) => {
  const [isSubscribedToPaidStickers, setIsSubscribedToPaidStickers] =
    useState(false);
  const [isUsingFreeTrial, setIsUsingFreeTrial] = useState(false);
  const location = useLocation();
  const loggedInUserEmail = useSelector(
    (state: any) => state.authentication.userData.email
  );

  useEffect(() => {
    const user = localStorage.getItem(USER_DATA_IN_LOCAL_STORAGE);
    if (user) {
      const userData = JSON.parse(user);
      setIsSubscribedToPaidStickers(userData.isSubscribedToPaidStickers);
      checkUserSubscription();
    }
  }, []);

  const checkUserSubscription = async () => {
    const subscriptionResponse = await getAxiosWithToken().post(
      'billing/user-subscriptions',
      { email: loggedInUserEmail }
    );
    const subscription = subscriptionResponse.data.subscriptions
      ? subscriptionResponse.data.subscriptions[0]
      : null;
    if (subscription && subscription.status === 'trialing') {
      setIsUsingFreeTrial(true);
    }
  };

  if (!localStorage.getItem(USER_DATA_IN_LOCAL_STORAGE)) {
    return null;
  }

  const adTypeComponent = () => {
    const locationPathname = location.pathname;
    switch (true) {
      case locationPathname.startsWith(
        `${RELATIVE_PAGE_PATHS.TRACKING}/${RELATIVE_LINKS_PROD.MEDICINE}`
      ):
        return (
          <AdSlot
            id="div-gpt-ad-1668693543692-0"
            path="/21663792601/Medical_Tracker"
            size={[[300, 250]]}
          />
        );
      case locationPathname.startsWith(
        `${RELATIVE_PAGE_PATHS.TRACKING}/${RELATIVE_LINKS_PROD.CRY}`
      ):
        return (
          <AdSlot
            id="div-gpt-ad-1668693543692-0"
            path="/21663792601/Cry_Tracker"
            size={[[300, 250]]}
          />
        );
      case locationPathname.startsWith(
        `${RELATIVE_PAGE_PATHS.TRACKING}/${RELATIVE_LINKS_PROD.FEEDING}`
      ):
        return (
          <AdSlot
            id="div-gpt-ad-1668693543692-0"
            path="/21663792601/Feeding_Tracker"
            size={[[300, 250]]}
          />
        );
      case locationPathname.startsWith(
        `${RELATIVE_PAGE_PATHS.TRACKING}/${RELATIVE_LINKS_PROD.WEIGHT_TRACKER}`
      ):
        return (
          <AdSlot
            id="div-gpt-ad-1668693543692-0"
            path="/21663792601/Weight_Tracker"
            size={[[300, 250]]}
          />
        );
      case locationPathname.startsWith(
        `${RELATIVE_PAGE_PATHS.TRACKING}/${RELATIVE_LINKS_PROD.BATHING}`
      ):
        return (
          <AdSlot
            id="div-gpt-ad-1668693543692-0"
            path="/21663792601/Bathing_Tracker"
            size={[[300, 250]]}
          />
        );
      case locationPathname.startsWith(
        `${RELATIVE_PAGE_PATHS.TRACKING}/${RELATIVE_LINKS_PROD.TEMPERATURE}`
      ):
        return (
          <AdSlot
            id="div-gpt-ad-1668693543692-0"
            path="/21663792601/Temperature_Tracker"
            size={[[300, 250]]}
          />
        );
      case locationPathname.startsWith(`${RELATIVE_PAGE_PATHS.SLEEP}`):
        return (
          <AdSlot
            id="div-gpt-ad-1668693543692-0"
            path="/21663792601/Sleep_Tracker"
            size={[[300, 250]]}
          />
        );
      case locationPathname.startsWith(
        `${RELATIVE_PAGE_PATHS.TRACKING}/${RELATIVE_LINKS_PROD.BREAST_FEEDING}`
      ):
        return (
          <AdSlot
            id="div-gpt-ad-1668693543692-0"
            path="/21663792601/Breastfeeding_Tracker"
            size={[[300, 250]]}
          />
        );
      case locationPathname.startsWith(`${RELATIVE_PAGE_PATHS.STICKERS_HOME}`):
        return <></>;
      default:
        return (
          <AdSlot
            id="div-gpt-ad-1668693543692-0"
            path="/21663792601/Denvenik_Banner"
            size={[[300, 250]]}
          />
        );
    }
  };

  return (
    <>
      {(!isSubscribedToPaidStickers || isUsingFreeTrial) && adTypeComponent()}
    </>
  );
};

export default AdSlotSpecificPage;
